import React, { useEffect } from 'react';
import "@fancyapps/ui/dist/fancybox/fancybox.css"; // Correct path for FancyBox 4
import { Fancybox } from "@fancyapps/ui";
import '../../styles/media-report/main.css';

const Main = () => {

    // Initialize FancyBox after component mounts
    useEffect(() => {
        Fancybox.bind("[data-fancybox='gallery']", {
            infinite: false,
            loop: true,
        });
    }, []);

    return (

        <div id="mediaReport">
            <div className="media-report-main pb-5">
                <div className="container border rounded">
                    <h3 className="text-left my-heading">Media Report</h3>
                    <main className="main">
                        <div className="container">
                            {/* <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/png/2024/08/kakori.png"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/png/2024/08/kakori.png"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/1.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/1.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/2.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/2.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/3.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/3.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div> */}
                            
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/11/ccsu_media_report/media%20report%205nov%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/11/ccsu_media_report/media%20report%205nov%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/11/ccsu_media_report/media%20report%2004%20nov%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/11/ccsu_media_report/media%20report%2004%20nov%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/11/ccsu_media_report/media%20report%2003%20nov%202026.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/11/ccsu_media_report/media%20report%2003%20nov%202026.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/11/ccsu_media_report/media%20report%202%20nov%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/11/ccsu_media_report/media%20report%202%20nov%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/11/ccsu_media_report/media%20report%201%20nov%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/11/ccsu_media_report/media%20report%201%20nov%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/10/media%20report%2031%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/pdf/2026/10/media%20report%2031%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/10/media%20report%2030%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/pdf/2026/10/media%20report%2030%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2029%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2029%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2028c%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2028c%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2027%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2027%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2026%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2026%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2025%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2025%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2024%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2024%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2023%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2023%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2022%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2022%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/medai%20report%2021%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/medai%20report%2021%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2020%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2020%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2019%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2019%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2018%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2018%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2017%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2017%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2016%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2016%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2015%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2015%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2014%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2014%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2013%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2013%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2012%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2012%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2010%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2010%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2009%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2009%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2008%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2008%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2007%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2007%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2006%20oct%202026.webp"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/10/media%20report%2006%20oct%202026.webp"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/jpg/2026/03/media-report-1.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/jpg/2026/03/media-report-1.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/jpg/2026/03/media-report-2.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/jpg/2026/03/media-report-2.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/jpg/2026/03/media-report-3.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/jpg/2026/03/media-report-3.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://cdn.ccsuniversity.ac.in/public/jpg/2026/03/media-report-4.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/jpg/2026/03/media-report-4.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            {/* <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/4.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/4.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div> */}
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/5.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/5.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/6.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/6.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/7.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/7.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div>
                            {/* <div className="card">
                                <div className="card-image">
                                    <a
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/8.jpg"
                                        className="lightbox"
                                        data-fancybox="gallery"
                                    >
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/08/8.jpg"
                                            alt="Gallery"
                                        />
                                    </a>
                                </div>
                            </div> */}
                        </div>
                    </main>
                </div>
            </div>
        </div>


    )
}

export default Main;